import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'Domain',
    returnTo: 'Domains'
  }),
  created() {
    this.$store.dispatch('company/getItems');
    this.$store.dispatch('country/getItems');
    this.$store.dispatch('configuration/getItems');
    this.$store.dispatch('stockLocation/getItems');
    this.$store.dispatch('workshop/getItems');
    this.$store.dispatch('transportCompany/getItems');
    this.$store.dispatch('language/getItems');
    this.$store.dispatch('fabric/getItems', {
      query: { sort: 'domainProductCode', domainid: this.$route.params.id, onlyActive: true, canbeusedasliningyn: true }
    });
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
